import React from 'react';
import './StatItem.scss';
import {SvgIcon} from '@/core/components/svgIcon/SvgIcon';

interface StatItemProps {
  icon: React.ReactNode;
  title: string;
  value: number;
  onClick?: () => void;
  hasLink: boolean;
}

export const StatItem: React.FC<StatItemProps> = ({icon, title, value, onClick, hasLink}) => {
  return (
    <div className="homestat-item">
      <div className="homestat-item__icon">{icon}</div>
      <div className="homestat-item__content">
        <div className="homestat-item__title">{title}</div>
        <div className="homestat-item__value">{value}</div>
      </div>
      {hasLink && (
        <div className="homestat-item__link" onClick={onClick}>
          <SvgIcon icon={'icon-arrow-more'} />
        </div>
      )}
    </div>
  );
};
